import { AlertTriangle, Loader2, X } from "lucide-react"

// Generic replacement for window.confirm() — the same "localhost:3000 says"
// browser dialog everywhere else in the app has already been moved off of.
export default function ConfirmModal({ open, title, message, confirmLabel = "Delete", busy = false, danger = true, onClose, onConfirm }) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={busy ? undefined : onClose} aria-hidden="true" />

      <div className="relative w-full max-w-md overflow-hidden rounded-xl border border-white/10 bg-ink-800 p-4 shadow-2xl">
        <div
          className="pointer-events-none absolute inset-x-0 top-0 h-[2px]"
          style={{ background: `linear-gradient(90deg, transparent, ${danger ? "#EF4444" : "#D9B36C"} 50%, transparent)` }}
          aria-hidden="true"
        />

        <div className="flex items-start gap-4">
          <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full border ${danger ? "border-red-500/30 bg-red-500/10 text-red-400" : "border-gold-500/30 bg-gold-500/10 text-gold-400"}`}>
            <AlertTriangle className="h-5 w-5" />
          </div>
          <div className="flex-1">
            <h2 id="confirm-modal-title" className="font-display text-base font-bold text-paper-0">{title}</h2>
            {message && <p className="mt-1 text-sm text-mist-300">{message}</p>}
          </div>
          <button onClick={onClose} disabled={busy} aria-label="Close" className="flex h-8 w-8 items-center justify-center rounded text-mist-400 transition-colors hover:text-paper-0 disabled:opacity-50">
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-5 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button onClick={onClose} disabled={busy} className="flex h-9 items-center justify-center rounded-lg border border-white/15 px-4 text-sm font-semibold text-paper-0 transition-colors hover:bg-white/5 disabled:opacity-50">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={busy}
            className={`flex h-9 items-center justify-center gap-2 rounded-lg px-4 text-sm font-semibold text-white transition-colors disabled:cursor-not-allowed disabled:opacity-40 ${danger ? "bg-red-500 hover:bg-red-400" : "bg-gold-500 text-ink-900 hover:bg-gold-400"}`}
          >
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
